export const IMAGE_TARGET = ".img-product";
export const IMAGE_PANEL = ".photo-panel";
